<mat-toolbar class="subtitulo">Funções</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <mat-toolbar class="titulopartes">Dados da Função</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

             <!-- #CARGO -->
             <mat-form-field fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Cargo:</mat-label>
                <mat-select  [(ngModel)]=funcao.cargo.id  name="cargo" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of cargos" [value]=i.id>
                        {{i.nome}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhum cargo
                    cadastrado</mat-hint>
            </mat-form-field>

            <!-- #NOME  -->
            <mat-form-field fxFlexOffset="20px" fxFlex="40%">
                <input  [(ngModel)]=funcao.nome #nome matInput maxlength="200" name="nome" placeholder="Nome:" required>
                <mat-hint align="end">{{nome.value.length}} / 200</mat-hint>
            </mat-form-field>

            <!-- #VALOR  -->
            <mat-form-field fxFlex="35%" fxFlexOffset="20px">
                <input currencyMask matInput maxlength="50" name="valorSalario"
                    placeholder="Valor da função:" [(ngModel)]="funcao.valorSalario"
                    [options]="{ prefix: '', thousands: '.', decimal: ',' }" required/>
                <span matPrefix>R$&nbsp;</span>
            </mat-form-field>

        </div>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
           
            <!-- #DESCRICAO  -->
            <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea [(ngModel)]="funcao.descricao" matInput #descricao name="descricao"  cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                    </textarea>
                <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
            </mat-form-field>
            
            <!-- #ATRIBUICOES  -->
            <mat-form-field  fxFlex="50%" appearance="outline">
                <mat-label>Atribuições:</mat-label>
                <textarea [(ngModel)]="funcao.atribuicoes" matInput #atribuicoes name="atribuicoes"  cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                    </textarea>
                <mat-hint align="end">{{atribuicoes.value.length}} / 200</mat-hint>
            </mat-form-field>

        </div>
       
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
           
            <!-- #CONHECIMENTOS  -->
            <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
                <mat-label>Conhecimentos Específicos:</mat-label>
                <textarea [(ngModel)]="funcao.conhecimentosEspecificos" matInput #conhecimentos name="conhecimentos"  cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                    </textarea>
                <mat-hint align="end">{{conhecimentos.value.length}} / 200</mat-hint>
            </mat-form-field>
            
            <!-- #COMPORTAMENTOS  -->
            <mat-form-field  fxFlex="50%" appearance="outline">
                <mat-label>Comportamentos Esperados:</mat-label>
                <textarea [(ngModel)]="funcao.comportamentosEsperados" matInput #comportamentos name="comportamentos"  cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                    </textarea>
                <mat-hint align="end">{{comportamentos.value.length}} / 200</mat-hint>
            </mat-form-field>

        </div>


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>
</div>